import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    button: {
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "center",
        overflow: "hidden",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    }
});

export const useStyles = ({
    controlHeights,
    isFocusVisible,
    currentRadius,
    shapeConfigs,
    borders,
    colors
}: {
    colors: NCoreUIKit.ActivePalette["colors"];
    controlHeights: NCoreUIKit.ControlHeights;
    shapeConfigs: NCoreUIKit.ShapeConfigs;
    borders: NCoreUIKit.Borders;
    isFocusVisible: boolean;
    currentRadius: number;
}) => {
    return {
        button: {
            backgroundColor: colors.system.state.overlay.fill.default,
            borderColor: colors.content.border.subtle,
            height: controlHeights.medium,
            width: controlHeights.medium,
            borderWidth: borders.line,
            ...getCornerStyle({
                radius: currentRadius,
                shapeConfigs
            }),
            ...getFocusRingStyle({
                colorKey: "default",
                isFocusVisible,
                isInset: true,
                borders,
                colors
            })
        } as ViewStyle
    };
};
export default stylesheet;
